export interface FuelingRecord {
  id: string;
  vehicleId: string;
  driverId: string | null;
  stationId: string | null;
  fuelType: string;
  quantityMl: number;
  priceCentsPerL: number;
  totalCents: number;
  odometerMeters: number | null;
  previousOdometerMeters: number | null;
  distanceMeters: number | null;
  consumptionMlPerKm: number | null;
  isFull: boolean;
  fueledAt: string;
  notes: string | null;
  source: 'manual' | 'csv_import' | 'mobile';
  isAnomaly: boolean;
  anomalyReason: string | null;
  receiptUploadId: string | null;
  createdAt: string;
  updatedAt: string;
  vehicle?: { id: string; plate: string; brand: string | null; model: string | null };
  station?: { id: string; name: string } | null;
}

export interface FuelingListResponse {
  data: FuelingRecord[];
  meta: { page: number; limit: number; total: number };
}

export interface FuelingSummary {
  totalLiters: number;
  totalCostCents: number;
  avgConsumptionKmPerL: number | null;
  avgPriceCentsPerL: number;
  recordCount: number;
  anomalyCount: number;
  costPerKmCents: number | null;
  byVehicle: Array<{
    vehicleId: string;
    plate: string;
    totalCostCents: number;
    totalLiters: number;
    avgKmPerL: number | null;
  }>;
  byMonth: Array<{
    month: string;
    totalCostCents: number;
    totalLiters: number;
    recordCount: number;
  }>;
}

export const FUEL_TYPE_LABELS: Record<string, string> = {
  diesel: 'Diesel',
  diesel_s10: 'Diesel S10',
  gasoline: 'Gasolina',
  ethanol: 'Etanol',
  flex: 'Flex',
  electric: 'Elétrico',
  cng: 'GNV',
  adblue: 'Arla 32',
};

/** Converte mL → L com 2 casas. */
export function mlToLiters(ml: number): number {
  return ml / 1000;
}

/** Converte centavos → R$ formatado. */
export function centsToReais(cents: number): string {
  return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/** Converte consumo mL/km → km/L. */
export function mlPerKmToKmPerL(mlPerKm: number): number {
  if (mlPerKm <= 0) return 0;
  return 1000 / mlPerKm;
}
